// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topic-editor-header {
    height: 6.4rem;
    max-height: 6.4rem;
    line-height: 6.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.8rem;
    font-size: 3.6rem;
    z-index:4;
}

.topic-editor-header .topic-editor-header__content {
    display: flex;
    align-items: center;
    gap: 1.8rem;
}

.topic-editor-header .topic-editor-header__content-grow {
    flex-grow: 1;
    max-width: 40%;
    display: flex;
}

.topic-editor-header .topic-editor-header__identifier {
    color: #cccccc;
}

.topic-editor-header .topic-editor-header__name {
    font-weight: 700;
    padding-left: 0.9rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.topic-editor-header__topic-version {
    white-space: nowrap;
}

.topic-editor-header__button-publish {
    width: 150px;
}

.topic-editor-header__button {
    white-space: nowrap;
}

.custom-spinner {
    position: relative;
    top: unset;
    left: unset;
    transform: unset;
}

.topic-editor-header__publish-dropdown {
    z-index: 1;
    display: flex;
}

.topic-editor-header__publish-dropdown-menu {
    font-size: small;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 3px 3px 2px rgb(0 0 0 / 25%);
    width: 14rem;
    line-height: initial;
    height: initial;
    max-height: initial;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px 0;
}

.topic-editor-header__topic-pairs-version {
    display: block;
    height: 3.6rem;
    width: auto;
    border-radius: 2px;
    border: none;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
        0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    color: #fff;
    background-color: #26a69a;
    font-size: 14px;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
    -webkit-transition: background-color 0.2s ease-out;
    transition: background-color 0.2s ease-out;
    cursor: pointer;
}

    .topic-editor-header__topic-pairs-version:disabled {
        box-shadow: none;
        background-color: #dfdfdf !important;
        cursor: default;
    }

        .topic-editor-header__topic-pairs-version:disabled:hover {
            background-color: #dfdfdf !important;
        }

.topic-editor-header__topic-pairs-version:focus-visible {
    outline-color: -webkit-focus-ring-color;
    outline-style: auto;
    outline-width: 1px;
}

.topic-editor-header__topic-pairs-version option:disabled {
    background-color: #c8c8c8;
    color: #fafeff;
}

.topic-editor-header__topic-pairs-version:hover {
    background-color: #2bbbad;
}

.topic-editor-header__publish-dropdown-option {
    width: 100%;
    /* line-height: initial; */
    /* width: 97%; */
    /* margin-left: auto;
    margin-right: auto;
    font-size: 14px;
    padding: 0;
    line-height: 1em; */
}
`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-editor/topic-editor-header/TopicEditorHeader.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,4CAA4C;IAC5C,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ;0EACsE;IACtE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,kDAAkD;IAClD,0CAA0C;IAC1C,eAAe;AACnB;;IAEI;QACI,gBAAgB;QAChB,oCAAoC;QACpC,eAAe;IACnB;;QAEI;YACI,oCAAoC;QACxC;;AAER;IACI,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;IAChB;;;;uBAImB;AACvB","sourcesContent":[".topic-editor-header {\r\n    height: 6.4rem;\r\n    max-height: 6.4rem;\r\n    line-height: 6.4rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 1.8rem;\r\n    font-size: 3.6rem;\r\n    z-index:4;\r\n}\r\n\r\n.topic-editor-header .topic-editor-header__content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1.8rem;\r\n}\r\n\r\n.topic-editor-header .topic-editor-header__content-grow {\r\n    flex-grow: 1;\r\n    max-width: 40%;\r\n    display: flex;\r\n}\r\n\r\n.topic-editor-header .topic-editor-header__identifier {\r\n    color: #cccccc;\r\n}\r\n\r\n.topic-editor-header .topic-editor-header__name {\r\n    font-weight: 700;\r\n    padding-left: 0.9rem;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.topic-editor-header__topic-version {\r\n    white-space: nowrap;\r\n}\r\n\r\n.topic-editor-header__button-publish {\r\n    width: 150px;\r\n}\r\n\r\n.topic-editor-header__button {\r\n    white-space: nowrap;\r\n}\r\n\r\n.custom-spinner {\r\n    position: relative;\r\n    top: unset;\r\n    left: unset;\r\n    transform: unset;\r\n}\r\n\r\n.topic-editor-header__publish-dropdown {\r\n    z-index: 1;\r\n    display: flex;\r\n}\r\n\r\n.topic-editor-header__publish-dropdown-menu {\r\n    font-size: small;\r\n    background-color: rgb(255, 255, 255);\r\n    box-shadow: 0px 3px 3px 2px rgb(0 0 0 / 25%);\r\n    width: 14rem;\r\n    line-height: initial;\r\n    height: initial;\r\n    max-height: initial;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    padding: 10px 0;\r\n}\r\n\r\n.topic-editor-header__topic-pairs-version {\r\n    display: block;\r\n    height: 3.6rem;\r\n    width: auto;\r\n    border-radius: 2px;\r\n    border: none;\r\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\r\n        0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\r\n    color: #fff;\r\n    background-color: #26a69a;\r\n    font-size: 14px;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n    white-space: nowrap;\r\n    -webkit-transition: background-color 0.2s ease-out;\r\n    transition: background-color 0.2s ease-out;\r\n    cursor: pointer;\r\n}\r\n\r\n    .topic-editor-header__topic-pairs-version:disabled {\r\n        box-shadow: none;\r\n        background-color: #dfdfdf !important;\r\n        cursor: default;\r\n    }\r\n\r\n        .topic-editor-header__topic-pairs-version:disabled:hover {\r\n            background-color: #dfdfdf !important;\r\n        }\r\n\r\n.topic-editor-header__topic-pairs-version:focus-visible {\r\n    outline-color: -webkit-focus-ring-color;\r\n    outline-style: auto;\r\n    outline-width: 1px;\r\n}\r\n\r\n.topic-editor-header__topic-pairs-version option:disabled {\r\n    background-color: #c8c8c8;\r\n    color: #fafeff;\r\n}\r\n\r\n.topic-editor-header__topic-pairs-version:hover {\r\n    background-color: #2bbbad;\r\n}\r\n\r\n.topic-editor-header__publish-dropdown-option {\r\n    width: 100%;\r\n    /* line-height: initial; */\r\n    /* width: 97%; */\r\n    /* margin-left: auto;\r\n    margin-right: auto;\r\n    font-size: 14px;\r\n    padding: 0;\r\n    line-height: 1em; */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
